import {
    all, select, put, take, takeEvery,
} from 'redux-saga/effects';
import { push as pushRoute } from 'connected-react-router';

import { extractQueryParameters, buildQueryParameters } from 'helpers/RoutesHelpers';
import { supportFormHasErrors } from '../constants/FieldsValidation';

import {
    postSupport,
    REQUEST_POST_SUPPORT_ERROR,
    REQUEST_POST_SUPPORT_SUCCESS,
} from '../../commons/reduxModules/APISupport';

import { getItemSelector as getMeSelector } from '../../commons/reduxModules/APIMe';

import { getLocationSelector } from '../../commons/selectors/RouterSelector';

import {
    generateNotification,
    rawAddNotification,
} from '../../services/Notifications';

import {
    POST_SUPPORT_THREAD,
    getCurrentMessageSelector,
    getCurrentEmailSelector,
    getCurrentPhoneSelector,
    getCurrentQuestionTypeSelector,
    isQuestionErrorsDisplayedSelector,
    showQuestionErrors,
    hideQuestionErrors,
    getCurrentNameSelector,
    getOrgaIdSelector,
    isSendingSelector,
} from '../reduxModules/App';

import Routes from '../constants/Routes';
import { getScopeSelector } from '../../commons/reduxModules/Authentication';
import Scopes from '../../constants/Scopes';

export function* callAction() {
    const [
        message,
        user,
        currentName,
        currentEmail,
        currentPhone,
        currentQuestionType,
        questionErrorsDisplayed,
        orgaId,
        scope,
        sending,
    ] = yield all([
        select(getCurrentMessageSelector),
        select(getMeSelector),
        select(getCurrentNameSelector),
        select(getCurrentEmailSelector),
        select(getCurrentPhoneSelector),
        select(getCurrentQuestionTypeSelector),
        select(isQuestionErrorsDisplayedSelector),
        select(getOrgaIdSelector),
        select(getScopeSelector),
        select(isSendingSelector),
    ]);

    const userName = user ? `${user.first_name || ''} ${user.last_name || ''}` : '';
    const userEmail = user ? user.email_address || '' : '';
    const name = currentName || userName || '';
    const email = currentEmail || userEmail || '';
    const phone = currentPhone || '';

    const notificationPayload = {
        bulkName: 'Echec de l\'envoi du message',
        state: 'error',
        message: 'Une erreur inconnue est survenue lors de l\'envoi de votre formulaire',
    };

    const hasErrors = supportFormHasErrors({
        name,
        message,
        email,
        currentQuestionType,
    });
    //  Trying to save with displayed errors
    if (hasErrors && questionErrorsDisplayed) return;
    //  Trying to save with hidden errors
    if (hasErrors) {
        yield put(showQuestionErrors());
        return;
    }

    if (sending) {
        return;
    }

    yield put(postSupport({
        subject: `Contact - ${currentQuestionType}`,
        type: 'CONTACT',
        full_name: name,
        email_address: email,
        phone,
        message,
        orga_id: orgaId,
    }));

    const action = yield take([
        REQUEST_POST_SUPPORT_ERROR,
        REQUEST_POST_SUPPORT_SUCCESS,
    ]);

    const location = yield select(getLocationSelector);
    const newLocation = location;
    const searchParameters = extractQueryParameters(location.search);
    searchParameters['support-modal'] = Routes.CONTACT_SUPPORT_SUCCESS.link;
    newLocation.search = buildQueryParameters(searchParameters);
    if (action.type === REQUEST_POST_SUPPORT_SUCCESS) {
        if (Scopes.USER === scope) {
            yield put(pushRoute(Routes.CONTACT_SUPPORT_SUCCESS.link));
        } else {
            yield put(pushRoute(newLocation));
        }
        yield put(hideQuestionErrors());
    } else {
        yield put(showQuestionErrors());
        yield put(rawAddNotification(
            generateNotification(notificationPayload),
        ));
    }
}

export function* watch() {
    yield takeEvery(POST_SUPPORT_THREAD, callAction);
}
